export default {
  BusinessPurchaseReturnComDetail: {
    purchaseText: 'Purchase Return Outbound',
    statusText: 'Status',
    operationLog: 'Operation Log',
    statusMeaning: 'Return Outbound Status',
    planQty: 'Document Quantity',
    alreadyQty: 'Outbound',
    waitQty: 'Unoutbound',
    informationText: 'Order Account Information',
    stockoutCode: 'Return Outbound Notification Number',
    resultCode: 'Return Outbound Result Number',
    typeMeaning: 'Return Outbound Type',
    supplierName: 'Supplier',
    warehouseName: 'Return Warehouse',
    purchaseCode: 'Purchase Order No.',
    auditDate: 'Review time',
    stockoutDate: 'Delivery Time',
    logisticsBusinessName: 'Logistics Company',
    logisticsNo: 'Waybill Number',
    recipientName: 'Addressee',
    recipientPhone: 'Mobile',
    recipientAddress: 'Delivery Address',
    notify: 'Notification',
    result: 'Result',
    one: 'Order ',
    log: ' Log',

    table: {
      title: 'Purchasing Return Product Information',
      spuPic: 'Product Image',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      skuName: 'SKU Name',
      planQty: 'Document Quantity',
      alreadyQty: 'Actual Inbound Quantity',
      waitQty: 'Uninbound Quantity',
      taxUnitPrice: 'The unit price including tax',
      taxRate: 'Tax Rate',
      taxPrice: 'Price Including Tax Amount',
      supplierSpuCode: 'Supplier Product Code',
      supplierSkuCode: 'Supplier SKU Code'
    }

  },
  BusinessPurchaseReturnComPage: {
    header: {
      queryCode: 'Return Outbound Order No.',
      codeText: 'Notification Number / Result Number',
      supplier: 'Supplier',
      supplierText: 'Supplier Code / Supplier Name',
      type: 'Return Outbound Type',
      warehouseCode: 'Return Warehouse',
      status: 'Return Outbound Status',
      purchaseCode: 'Purchase Order No.',
      spuCode: 'Product Code',
      skuCode: 'SKU',
      startData: 'Start Date',
      endData: 'End Date',
      reviewTime: 'Review time',
      deliveryTime: 'Delivery Time',
      logisticsBusinessName: 'Logistics Company',
      logisticsNo: 'Shipment Number',
    },

    review: 'Review',
    antiAudit: 'Anti audit',
    returnWarehouse: 'Return Outbound',
    export: 'Export',
    errorText: 'There are orders with incorrect status that cannot perform the current operation',
    msgError1: 'Only orders waiting for review can be edited',
    msgError2: 'Please select an order waiting for outbound or notification to WMS to operate',
    msgBox1: 'Whether ',
    msgBox2: 'Selected orders',
    msgBox3: 'Whether to cancel the selected document',
    msgBox4: 'Whether to confirm the return of goods out of the warehouse？',
    downName1: 'Purchase return outbound notification export',
    downName2: 'Purchase return outbound result export',

    table: {
      statusMeaning: 'Return Outbound Status',
      typeMeaning: 'Return Outbound Type',
      warehouseName: 'Return Warehouse',
      supplierCode: 'Supplier Code',
      supplierName: 'Supplier Name',
      purchaseCode: 'Purchase Order No.',
      logisticsBusinessName: 'Logistics Company',
      logisticsNo: 'Shipment Number',
      planQty: 'Document Quantity',
      alreadyQty: 'Shipped Quantity',
      amount: 'Total Amount',
      recipientName: 'Full Name',
      recipientPhone: 'Mobile',
      recipientAddress: 'Delivery Address',
      auditDate: 'Review Time',
      auditName: 'Full Name',
      stockoutDate: 'Delivery Time',
      sourceMeaning: 'Source',
      code: 'Return Outbound Result Number',
      stockoutCode: 'Return Outbound Notification Number',
    }
  },
};
